import axios from "axios";

export const downloadLessonContent = (filePath) => async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/students/download/${filePath}`,
      { responseType: "blob" }
    );

    // Build a download URL
    const url = window.URL.createObjectURL(new Blob([res.data]));

    // Extract original filename (remove UUID + course folder)
    const parts = filePath.split("/");
    const rawFile = parts[parts.length - 1]; // last part = "UUID_original.pdf"
    const displayName = rawFile.split("_").slice(1).join("_") || rawFile;

    // Create and trigger hidden link
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", displayName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Download failed:", error);
  }
};
